import { styled } from "styled-components";

export const ModalContent = styled.div`
  background-color: #f7f9fc;
  border-radius: 12px;
  padding: 2.5rem;
  width: 95%;
  max-width: 900px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-height: 90vh;
  overflow-y: auto;
  transform: scale(0.95);
  transition: transform 0.3s ease-out;

  h3 {
    font-size: 1.8rem;
    color: #2c3e50;
    margin-top: 0;
    font-weight: 600;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 2.5rem;
`;

export const FormSection = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);

  h4 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #34495e;
    border-bottom: 2px solid #3498db;
    padding-bottom: 0.75rem;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  label {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.25rem;
    font-weight: 500;
    color: #555;
    font-size: 0.9rem;

    span {
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
  }

  input, textarea, select {
    padding: 0.8rem 1rem;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    font-size: 1rem;
    font-family: inherit;
    transition: all 0.3s ease-in-out;
    width: 100%;
    box-sizing: border-box;
    background-color: #fcfdfe;

    &:focus {
      outline: none;
      border-color: #3498db;
      box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
    }
  }

  textarea {
    resize: vertical;
    min-height: 120px;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 2rem;
  border-top: 1px solid #e9ecef;
  margin-top: 2rem;
`;

export const StyledButton = styled.button`
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const CancelButton = styled(StyledButton)`
  background-color: #e9ecef;
  color: #34495e;
  &:hover:not(:disabled) {
    background-color: #dcdfe6;
  }
`;

export const ApproveButton = styled(StyledButton)`
  background-color: #2ecc71;
  color: #fff;
  &:hover:not(:disabled) {
    background-color: #27ae60;
  }
`;

export const ErrorMessage = styled.p`
  color: #e74c3c;
  text-align: center;
  background-color: #fdeded;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  margin-right: 0.5rem;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export const ImagePreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f0f2f5;
  border-radius: 8px;
  border: 1px dashed #ccc;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
`;

export const MediaActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const MediaButton = styled.button`
  background-color: #dc3545; /* Red for delete */
  color: white;
  border: none;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;

  &:hover {
    background-color: #c82333;
  }

  &:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
  }
`;

export const AddMediaInput = styled.input`
  margin-top: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
`;